import { ReactNode } from "react";

type ToastType = "success" | "error" | "info";

export const toast = (
  message: ReactNode,
  type: ToastType = "info",
  duration: number = 1000,
) => {
  window.dispatchEvent(
    new CustomEvent("app-toast", {
      detail: { message, type, duration },
    }),
  );
};
